<template>
  <div id="order-detail">
    <wrld-container :breadcrumbs="this.breadcrumbs" :pageIsLoading="tmpOrder === null && (orders.isFetching || isFetching)">
      <div v-if="tmpOrder === null"><h2>Unexisting order</h2></div> <!-- TODO -->
      <div v-else>
        <wrld-out-of-box :title="$t('orders.order') +' - ' + tmpOrder.code">
          <template v-slot:headerBtns>
            <v-btn outlined class="mr-4 px-8">
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn outlined class="mr-4 px-8">
              <v-icon>share</v-icon>
            </v-btn>
            <v-btn
              class="mr-4 px-8"
              outlined
              color="accent"
              @click="gotoEditOrder(tmpOrder.code)"
            >{{$t('buttons.edit')}}</v-btn>
            <wrld-confirm-btn v-model="delete_modal_opened" @confirm="callDeleteOrder(tmpOrder.code)">
              <v-btn class="mr-4" outlined color="accent" @click="delete_modal_opened=true">
                <v-icon>delete</v-icon>{{$t('buttons.delete')}}
              </v-btn>
            </wrld-confirm-btn>
            <!-- <v-btn
              outlined
              color="accent"
              @click="callDeleteOrder(tmpOrder.code)"
            >{{$t('buttons.delete')}}</v-btn> -->
          </template>
        </wrld-out-of-box>
        <OrderDetailOverview :order="tmpOrder" />
        <OrderDetailPackages
          :packages="tmpOrder.packages"
          :isFetching="orders.isFetching"
        />
      </div>
    </wrld-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router'
import OrderDetailOverview from '@/components/orders/OrderDetailOverview.vue'
import OrderDetailPackages from '@/components/orders/OrderDetailPackages.vue'
import axios from '@/plugins/axios-instance.js'

export default {
  name: 'OrderDetail',
  components: {
    OrderDetailOverview,
    OrderDetailPackages
  },
  data () {
    return {
      order: null,
      delete_modal_opened: false,
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.t('orders.orders'), disabled: false, href: '#/orders' },
        { text: this.$i18n.t('detail'), disabled: true }
      ],
      isFetching: true
    }
  },
  methods: {
    ...mapActions({
      fetchLocationByID: 'fetchLocationByID',
      updateOrder: 'updateOrder',
      deleteOrder: 'deleteOrder',
      showSnackbar: 'showSnackbar'
    }),
    async fetchData () {
      let orderID = this.route.params.orderID
      // TODO: what if orderID is undefined?
      await this.fetchOrder(orderID)
    },
    getLocationByID (locationID) {
      let loc = this.locations.data[locationID]
      if (loc === undefined) {
        return {
          company: 'Unknow company',
          company_ref: '0',
          address: {
            street: 'Unknow',
            street_number: '',
            country: '',
            city: '',
            postal_code: ''
          },
          coordinates: {
            lat: 0,
            lng: 0
          }
        }
      }
      return loc
    },
    gotoEditOrder (orderID) {
      router.push({ name: 'EditOrder', params: { orderID: orderID } })
    },
    callDeleteOrder (orderID) {
      this.deleteOrder(orderID)
      let snackMsg = ''
      let snackColor = ''
      if (this.orders.error) {
        snackMsg = this.$i18n.t('snacbars.error')
        snackColor = 'errorr'
      } else {
        snackMsg = this.$i18n.t('snackbars.order_deleted')
        snackColor = 'success'
      }
      this.showSnackbar({ message: snackMsg, color: snackColor })
      router.push({ name: 'Orders' })
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async fetchOrder (orderID) {
      await this.sleep(1000)
      // TODO: move it to vuex store from here
      let param = this.replaceAll(orderID, '/', '%2F')
      let url = `https://8avugx3xy8.execute-api.eu-west-1.amazonaws.com/prod/orders/${param}`

      axios.get(url).then(resp => {
        this.order = this.transformOrder(resp.data)
        this.fetchLocationByID(resp.data.origin_id)
        this.fetchLocationByID(resp.data.destination_id)
      }).catch(error => {
        console.log(error)
        // this.isFetching = false
      })
    },
    transformOrder (order) {
      return order
    },
    replaceAll (str, find, replace) {
      return str.replace(new RegExp(find, 'g'), replace)
    }
  },
  async created () {
    this.isFetching = true
    await this.fetchData()
    this.isFetching = false
  },
  computed: {
    ...mapState(['route', 'orders', 'locations']),
    tmpOrder () {
      let order = this.order
      if (order === null) {
        return null
      }

      this.$set(order, 'origin', this.getLocationByID(order.origin_id))
      this.$set(order, 'destination', this.getLocationByID(order.destination_id))

      for (let i = 0; i < order.packages.length; i++) {
        order.packages[i].code = order.code + '-' + i
      }
      return order
    }
  }
}
</script>
